import { FontItem } from "~/interfaces/common"
import { IScene, ILayer, IStaticText } from "@agenteresolve/types"

const getFontsFromObjects = (objects: Partial<ILayer>[]) => {
  let fonts: any[] = []
  for (const object of objects) {
    if (object.type === "StaticText" || object.type === "DynamicText") {
      const text = object as Required<IStaticText>
      fonts.push({
        name: text.fontFamily,
        url: text.fontURL,
        options: {
          style: text.fontStyle || "normal",
          weight: text.fontWeight || 400,
        },
      })
    }
    if (object.type === "Group") {
      // @ts-ignore
      let groupFonts = getFontsFromObjects(object.objects)

      fonts = fonts.concat(groupFonts)
    }
  }
  return fonts
}

export const loadTemplateFonts = async (design: IScene) => {
  const fonts = getFontsFromObjects(design.layers)
  if (fonts.length > 0) {
    await loadFonts(fonts)
  }
}

export const loadFonts = (fonts: FontItem[]) => {
  const promisesList = fonts.map((font) => {
    const descriptors: FontFaceDescriptors = {}
    if (font.options?.style) descriptors.style = font.options.style
    if (font.options?.weight != null) descriptors.weight = String(font.options.weight)
    return new FontFace(font.name, `url(${font.url})`, descriptors).load().catch((err) => err)
  })
  return new Promise((resolve, reject) => {
    Promise.all(promisesList)
      .then((res) => {
        res.forEach((uniqueFont) => {
          if (uniqueFont && uniqueFont.family) {
            document.fonts.add(uniqueFont)
            resolve(true)
          }
        })
      })
      .catch((err) => reject(err))
  })
}
